import { Reveal, PageHero, GoldBtn } from "@/components/Shared";
import { EVENT } from "@/data/content";

const COPY = {
    privacy: {
        title: "Privacy Policy",
        updated: "Effective for Startup MahaBazaar 2027",
        sections: [
            { h: "What We Collect", p: "When you register your interest, submit an enquiry or subscribe to updates, we collect the details you provide — typically your name, email address, phone number, organisation and message. We do not collect more than we need to respond to you." },
            { h: "How We Use It", p: "Your information is used solely to respond to your enquiry, process your registration interest for Startup MahaBazaar 2027, and — if you subscribe — to send festival announcements, programme reveals and updates." },
            { h: "What We Never Do", p: "We do not sell, rent or trade your personal information. We do not share your details with third parties except where required to deliver the festival or by law." },
            { h: "Your Choices", p: "You may ask us at any time to update or delete the information you have shared. Write to us through the contact page and we will act on your request." },
        ],
    },
    terms: {
        title: "Terms & Conditions",
        updated: "Effective for Startup MahaBazaar 2027",
        sections: [
            { h: "The Festival", p: `Startup MahaBazaar 2027 takes place ${EVENT.dates} at ${EVENT.venue}. Programme, speakers, exhibitors and experiences are subject to change and will be announced through official channels.` },
            { h: "Registrations & Enquiries", p: "Submitting a registration of interest or enquiry through this website does not constitute a confirmed pass, booth or partnership. Confirmations, tariffs and participation terms are communicated separately by the organising team." },
            { h: "Content & Fidelity", p: "Event statistics presented on this website reflect the official festival brochure and projections. Details marked “Coming Soon” or “To Be Announced” will be updated as they are finalised." },
            { h: "Conduct", p: "Startup MahaBazaar is a celebration of builders. We expect all participants to engage with respect, integrity and the spirit of collaboration." },
        ],
    },
    cookies: {
        title: "Cookie Policy",
        updated: "Effective for Startup MahaBazaar 2027",
        sections: [
            { h: "What We Use", p: "This website uses essential storage to remember preferences such as your saved programme schedule, and privacy-respecting analytics to understand how visitors experience the site." },
            { h: "What We Don't Use", p: "We do not use advertising trackers or sell behavioural data. No cross-site profiling takes place on this website." },
            { h: "Managing Cookies", p: "You can clear or block cookies and local storage through your browser settings at any time. Core content of the website will continue to work." },
        ],
    },
};

export default function LegalPage({ kind }) {
    const doc = COPY[kind] || COPY.privacy;
    return (
        <div data-testid={`legal-${kind}-page`}>
            <PageHero eyebrow="Legal" title={<span className="gold-text">{doc.title}</span>} sub={doc.updated} />
            <section className="py-16 md:py-24">
                <div className="container-x max-w-3xl space-y-10">
                    {doc.sections.map((s, i) => (
                        <Reveal key={s.h} delay={i * 60}>
                            <div className="border-l border-[var(--line)] pl-7">
                                <h2 className="font-display text-2xl text-[var(--ivory)]">{s.h}</h2>
                                <p className="mt-3 text-sm md:text-base text-muted-luxe leading-relaxed">{s.p}</p>
                            </div>
                        </Reveal>
                    ))}
                    <Reveal className="pt-6">
                        <GoldBtn to="/contact" variant="outline" testid="legal-contact-btn">Questions? Contact Us</GoldBtn>
                    </Reveal>
                </div>
            </section>
        </div>
    );
}
